import Vue from 'vue';

// Styles and Icons
import '@mdi/font/css/materialdesignicons.css';
import './assets/css/global-styles.scss';
import 'vue-plyr/dist/vue-plyr.css';

// Plugins
import axios from 'axios';
import i18n from './plugins/i18n';
import NotificationSoundManager from './plugins/notificationSoundManager';
import store from './store';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import moment from 'moment-timezone';
import VueTour from 'vue-tour';
import VuePlyr from 'vue-plyr';

require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

const notificationSoundManager = new NotificationSoundManager();
Vue.use(notificationSoundManager);

Vue.use(require('vue-moment'), {
  moment
});
Vue.use(VuePlyr, {
  plyr: {}
})
Vue.prototype.$http = axios;

// Disable DEV/PROD console message
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  i18n,
  render: h => h(App),
  store,
  vuetify
}).$mount('#app');
